module.exports = __webpack_public_path__ + "cdcdcc1c76a0060d3bda22ac1d61df25.png";